import { render, staticRenderFns } from "./test_alarm_card.vue?vue&type=template&id=0de77176&"
import script from "./test_alarm_card.vue?vue&type=script&lang=js&"
export * from "./test_alarm_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports